var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    backgroundPosition: ("-" + (this.coordinates.x) + "px -" + (this.coordinates.y) + "px"),
  }),attrs:{"id":"movingBackground"}})}
var staticRenderFns = []

export { render, staticRenderFns }